import OrderPayment from "./views/OrderPayment.vue";
import Company from "./views/company/Company.vue";
import NewOrder from "./views/company/customer/NewOrderView.vue";
import Dashboard from "./views/company/customer/DashboardView.vue";
import Beneficiaries from "./views/company/customer/BeneficiariesView.vue";
import DeliveryPoints from "./views/company/customer/DeliveryPointsView.vue";
import Orders from "./views/company/customer/OrdersView.vue";

export default [
	{
		path: "/",
		name: "company_login",
		component: Company,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: "",
		name: "login",
		component: Company,
		meta: {
			requiresAuth: true
		}
	},

	// customer
	{
		path: "/company",
		name: "company",
		component: Company,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: "/company/search",
		name: "company_search",
		component: Company,
		meta: {
			requiresAuth: true
		}
	},
	{
		path: "/customer/dashboard",
		name: "customer_dashboard",
		component: Dashboard,
		params: { menu: "dashboard" },
		meta: {
			requiresAuth: true
		}
	},
	{
		path: "/customer/orders",
		name: "customer_orders",
		component: Orders,
		params: { menu: "orders" },
		meta: {
			requiresAuth: true
		}
	},
	{
		path: "/customer/new_order",
		name: "customer_new_order",
		component: NewOrder,
		params: { menu: "new_order" },
		meta: {
			requiresAuth: true
		}
	},
	{
		path: "/customer/beneficiaries",
		name: "customer_beneficiaries",
		component: Beneficiaries,
		params: { product: 0 },
		meta: {
			requiresAuth: true
		}
	},
	{
		path: "/customer/delivery_points",
		name: "delivery_points",
		component: DeliveryPoints,
		params: { product: 0 },
		meta: {
			requiresAuth: true
		}
	},
	{
		path: "/customer/faq",
		name: "customer_faq",
		component: Company,
		params: { menu: "faq" },
		meta: {
			requiresAuth: true
		}
	},
	{
		path: "/customer/account",
		name: "customer_account",
		component: Company,
		params: { menu: "account" },
		meta: {
			requiresAuth: true
		}
	},
	{
		path: "/customer/contact",
		name: "customer_contact",
		component: Company,
		params: { menu: "contact" },
		meta: {
			requiresAuth: true
		}
	},
	{
		path: "/customer/terms",
		name: "customer_terms",
		component: Company,
		params: { menu: "terms" },
		meta: {
			requiresAuth: true
		}
	},
	{
		path: "/customer/gdpr",
		name: "customer_gdpr",
		component: Company,
		params: { menu: "gdpr" },
		meta: {
			requiresAuth: true
		}
	},
	{
		path: "/customer/payment",
		name: "customer_payment",
		component: Company,
		meta: {
			requiresAuth: true
		}
		// params: {menu: "gdpr"},
	},
	{
		path: "/order_payment",
		name: "order_payment",
		component: OrderPayment,
		meta: {
			requiresAuth: false

		}
	},
]